import { Fragment } from 'react';
import { type AppRouteProps, AppRoutes } from './app-routes.jsx';
import useAntdApp from './compts/antd-app/index.jsx';
import { ContentLayoutCheck } from './compts/content-layout-check/index.jsx';
import { IframeTabRoutesTiming } from './compts/routes-timing/iframe-tab-timing.jsx';
import { LayoutPage } from './layout/layout-page/index.jsx';
import { type BootstrapOptions } from './types/index.js';

export type AppProps = AppRouteProps & {
  iframeTabAloneView?: boolean;
  layoutMode: BootstrapOptions['layoutMode'];
  LayoutComponent: BootstrapOptions['LayoutComponent'];
  hideHeader?: boolean;
  layoutPageClassName?: string;
  hideBreadsPathList: BootstrapOptions['hideBreadsPathList'];
  showProdEnvGuide: BootstrapOptions['showProdEnvGuide'];
  hidenEnvGuide: BootstrapOptions['hidenEnvGuide'];
  developmentEnvGuideConfigs: BootstrapOptions['developmentEnvGuideConfigs'];
};

/**
 * 无结构渲染，用于 layoutMode 为 no-layout、iframe-tab 场景
 * @param props
 * @returns
 */
export const AppNoLayout = (props: AppProps) => {
  useAntdApp();

  const LayoutContent = props.LayoutComponent || LayoutPage;

  return (
    <ContentLayoutCheck
      layoutMode={props.iframeTabAloneView ? undefined : props.layoutMode}
    >
      <Fragment>
        {props.layoutMode === 'iframe-tab' && <IframeTabRoutesTiming />}
        <LayoutContent
          hideHeader={props.hideHeader}
          className={props.layoutPageClassName}
          showDevFloatHelp={
            props.layoutMode != 'iframe-tab' && props.hidenEnvGuide !== true
          }
          developmentEnvGuideConfigs={props.developmentEnvGuideConfigs}
          showProdEnvGuide={props.showProdEnvGuide}
        >
          <AppRoutes {...props} />
        </LayoutContent>
      </Fragment>
    </ContentLayoutCheck>
  );
};
